import AntdBreadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";

export const careersrBreadcrumbs = [{ text: "Careers", link: "" }];

export const careernavBarData = [
  {
    name: "Careers",
    navigatePath: "/careers",
  },
  {
    name: "Job Post",
    navigatePath: "/careerjobpost",
  },
  { name: "Department/Function", navigatePath: "/careerdepartment" },
  { name: "Position / Designation", navigatePath: "/careerposition" },
];

export const statuses = ["Active", "Inactive"];

export const Gender = ["Male", "Female"];

/* job post  */
export const JobPostBreadcrumbs = () => {
  const breadcrumbsList = [
    { text: "Blogs", link: "/healtharticle" },
    { text: "Blog Search Keyword", link: "" },
  ];

  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};

export const DepartmentBreadcrumbs = () => {
  const breadcrumbsList = [
    { text: "Careers", link: "/healtharticle" },
    { text: "  Department / Function", link: "" },
  ];
  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};

/*  positions*/

export const PositionBreadcrumbs = () => {
  const breadcrumbsList = [
    { text: "Careers", link: "/careers" },
    { text: " Position / Designation", link: "" },
  ];
  return (
    <AntdBreadcrumbs
      className="healthsyMasterBreadCrumbs"
      breadcrumbsList={breadcrumbsList}
    />
  );
};
